// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cost-statistics-skeleton{height:100px;display:flex;padding:0 20px}.cost-statistics-skeleton__inner{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
